import { AsButton } from '@adserve/adserve-react-components';
import React from 'react';
import { AttachmentType } from '../../../../constants/Enums';

const CampaignAttachmentCreateButton = ({
    attachment = {},
    currentFile,
    attachmentTypeId,
    progress = 0,
    onClick,
    isEditing = false
}) => {
    const isDisabled = () => {
        if (progress > 0 && progress < 100) {
            return true;
        }
        if (attachment.name?.length < 3) {
            return true;
        }
        if (attachmentTypeId === AttachmentType.NOTE.id && attachment.value === undefined) {
            return true;
        }
        if (attachmentTypeId === AttachmentType.ATTACHMENT.id && currentFile === undefined) {
            return true;
        }
        return false;
    };

    const btnText = () => {
        if (attachmentTypeId === AttachmentType.ATTACHMENT.id) {
            if (progress > 0 && progress < 100) {
                return 'Uploading';
            } else {
                return 'Upload';
            }
        }
        if (attachmentTypeId === AttachmentType.NOTE.id) {
            return 'Save';
        } else {
            return 'Upload';
        }
    };

    return (
        <AsButton
            id='uploadBtn'
            handleClick={onClick}
            disabled={isDisabled()}
            style={{ height: 34, fontSize: 15, width: 'max-content', padding: '0 10px', minWidth: 120 }}
        >
            {btnText()}
        </AsButton>
    );
};

export default CampaignAttachmentCreateButton;
